// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__v7F6U","card":"styles_card__pzOh_","value":"styles_value__V2_PH","label":"styles_label__U1IiJ"};